"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _icon = _interopRequireDefault(require("../../components/icon"));
var _externalLink = _interopRequireDefault(require("../../icons/external-link"));
require("./external-link.css");
var _excluded = ["ariaDescription", "aria-label", "children", "className", "href", "visualStyle"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * `ExternalLink` is a pre-stylized link that opens up a new window/tab when clicked.
 *
 * Any additional props will be passed to the anchor element
 */
var ExternalLink = function ExternalLink(_ref) {
  var _ref$ariaDescription = _ref.ariaDescription,
    ariaDescription = _ref$ariaDescription === void 0 ? 'Opens in a new window' : _ref$ariaDescription,
    ariaLabel = _ref['aria-label'],
    children = _ref.children,
    className = _ref.className,
    href = _ref.href,
    _ref$visualStyle = _ref.visualStyle,
    visualStyle = _ref$visualStyle === void 0 ? 'text' : _ref$visualStyle,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("a", _extends({
    "aria-label": "".concat(ariaLabel || children, ", ").concat(ariaDescription),
    className: (0, _classnames["default"])('sb-external-link--link items-center', _defineProperty({
      'color-greenStarbucks': visualStyle === 'text',
      'sb-external-link--button': visualStyle === 'button'
    }, className, Boolean(className))),
    href: href,
    rel: "noopener noreferrer",
    target: "_blank"
  }, otherProps), children && /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('mr1', {
      'sb-external-link--text': visualStyle === 'text'
    })
  }, children), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    path: _externalLink["default"],
    size: "18px"
  }));
};
ExternalLink.displayName = 'ExternalLink';
ExternalLink.propTypes = process.env.NODE_ENV !== "production" ? {
  /** If the text of your link does not indicate it opens in a new window, please use this prop to provide an accessible helper message such as 'opens in a new window'.  Defaults to 'Opens in a new window'*/
  ariaDescription: _propTypes["default"].string,
  /** Used to append classes to the default classes */
  className: _propTypes["default"].string,
  /** The `href` value of the anchor tag */
  href: _propTypes["default"].string.isRequired,
  /** The text content for the link. Also used in the aria label. */
  children: _propTypes["default"].string.isRequired,
  /** Visual style of the external link. Defaults to 'text' */
  visualStyle: _propTypes["default"].oneOf(['button', 'text'])
} : {};
var _default = exports["default"] = ExternalLink;